<template>
	<div class="modal-ok" data-id="ok-modal" @click.stop>
		<div class="container">
			<header class="w-full header">
				<h2 class="title">{{ displayTitle }}</h2>
			</header>

			<hr class="horizontal-line" />

			<p class="description mt mb">{{ displayDescription }}</p>

			<div class="footer">
				<ui-button class="btn success" color="green" data-id="ok-modal-btn" v-tap="close">
					{{ displayButtonName }}
				</ui-button>
			</div>
		</div>
	</div>
</template>

<script setup lang="js">
import { computed } from 'vue'

const props = defineProps({
	modal: {
		type: Object,
		default: () => ({})
	},
	title: {
		type: String
	},
	description: {
		type: String
	},
	buttonName: {
		type: String,
		default: 'Ok!'
	}
})

const emit = defineEmits(['close'])

const displayTitle = computed(() => props.modal?.title || props.title)
const displayDescription = computed(() => props.modal?.description || props.description)
const displayButtonName = computed(() => props.modal?.buttonName || props.buttonName)

function close() {
	emit('close')
}
</script>

<style lang="stylus" scoped>
$black = #54606C

.w-full
	width 100%

.header
	display flex
	justify-content center
	align-items center

.container
	border-radius 16px
	padding 16px 24px
	display flex
	flex-direction column
	justify-content center
	align-items center
	width 720px
	max-width 95vw !important
	background-color #fff
	padding-block 16px

	.title
		color $black
		text-align center
		font-size 2.2rem
		padding-bottom 8px

	.description
		color $black
		font-size 2rem
		text-align center
		text-wrap balance

.footer
	width 100%
	display flex
	justify-content center
	margin-top 16px
	margin-bottom 8px
	.btn
		height fit-content
		padding-block 8px
		width fit-content
		font-size 16px

.horizontal-line
	width 100%
	height 2px
	margin-bottom 9px
	border none
	background-color blue

.modal-ok
	flex center
	height 100%
	width 100%

.mt
	margin-top 24px
.mb
	margin-bottom 24px
</style>
